import React from 'react'
import './Travels.min.css'
import { Outlet, Link } from "react-router-dom";
import TravelsPlanned from '../TravelsPlanned/TravelsPlanned';
const Travels = () => {
  return (
    <div>
      <div className='travel'>
        <Link to='../'>Zaplanowane</Link>
        <Link to='/Zakonczone'>Zakończone</Link>
      </div>
      <TravelsPlanned />
      <Outlet />
    </div>
  )
}

export default Travels